import request from '../../utils/request';

// OVO-227 — Monitoring → Airtable sync errors. Cross-order list of Airtable
// PATCH attempts that ended FAILED (429 rate-limit, timeout, 4xx/5xx), a count
// for the menu badge, per-row/bulk delete, and a resend path.
export function getAirtableErrors(params) {
  return request('/airtable-logs/errors', { method: 'GET', params });
}

export function getAirtableErrorCount() {
  return request('/airtable-logs/errors/count', { method: 'GET' });
}

export function deleteAirtableLog(id) {
  return request(`/airtable-logs/${id}`, { method: 'DELETE' });
}

export function deleteAllAirtableErrors() {
  return request('/airtable-logs/errors', { method: 'DELETE' });
}

export function deleteAirtableLogsByIds(ids) {
  return request('/airtable-logs/bulk-delete', { method: 'POST', data: { ids } });
}

// Resend a single order's status sync (idempotent — pushes current status).
export function resendOrderAirtable(orderCode) {
  return request(`/airtable-logs/resend-order/${orderCode}`, { method: 'POST' });
}

// Resync every order on a route.
export function resyncRouteAirtable(routeId) {
  return request(`/airtable-logs/resync-route/${routeId}`, { method: 'POST' });
}
